import React from 'react';
import '../Rankings.css';

const PersonRow = React.memo(({ person, voteCount, handleVote }) => {
    const getKarmaColorClass = (v) => {
        if (!v) return 'karma-neutral';
        return v < 0 ? 'karma-negative' : 'karma-positive';
    };

    const calculateAge = (dob) => {
        if (!dob) return null;
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const age = calculateAge(person.dob);


    return (
        <div
            className="person-row-card"
            role="article"
            aria-label={`${person.name} karma card`}
        >

            <div className="karma-section">
                <div className="vote-controls">
                    <button
                        className="vote-btn up"
                        onClick={() => handleVote(person.id, 1)}
                        aria-label={`Give karma to ${person.name}`}
                    >
                        <div className="icon-container">
                            <span className="icon" aria-hidden="true">▲</span>
                        </div>
                        <span className="label">Give</span>
                    </button>
                    <div className={`person-karma-display ${getKarmaColorClass(voteCount)}`} aria-live="polite">
                        {voteCount}
                        <span className="person-karma-label">Karma</span>
                    </div>
                    <button
                        className="vote-btn down"
                        onClick={() => handleVote(person.id, -1)}
                        aria-label={`Take karma from ${person.name}`}
                    >
                        <div className="icon-container">
                            <span className="icon" aria-hidden="true">▼</span>
                        </div>
                        <span className="label">Take</span>
                    </button>
                </div>
            </div>

            <div className="profile-section">
                <div className="profile-card-image-container">
                    <img src={person.image} alt={person.name} loading="lazy" className="profile-card-image" />
                    <div className="profile-card-overlay">
                        <h2 className="person-name">{person.name}</h2>
                        <div className="person-details-stack">
                            {age && <div className="detail-row">{age} years old</div>}
                            {person.birthplace && <div className="detail-row">{person.birthplace}</div>}
                        </div>
                        {person.nicknames && <p className="nicknames">"{person.nicknames}"</p>}
                    </div>
                </div>
            </div>

            <div className="details-section">
                <div className="info-grid">
                    <div className="info-item">
                        <span className="info-label">Occupation</span>
                        <div className="info-value">
                            {person.occupation || 'Unknown'}
                        </div>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Net Worth</span>
                        <div className="info-value highlight">
                            {person.net_worth ? (person.net_worth === 'Unknown' ? 'Unknown' : `$${person.net_worth}`) : 'Unknown'}
                        </div>
                    </div>
                </div>
                <div className="achievements-section">
                    <span className="info-label">Achievements</span>
                    <p className="achievements-text">{person.achievements}</p>
                    {person.records && <p className="records-text">{person.records}</p>}
                </div>
            </div>
        </div>
    );
});

export default PersonRow;
